export default __webpack_public_path__ + "b4aee0e91033849083fd9d98a00e40c2.ttf";